import * as React from 'react'
import './CalendarLegend.scss'
import { ICalendarLegendEntryProps } from './CalendarLegendEntry'

export interface ICalendarLegendProps {
  children:
    | Array<React.ReactElement<ICalendarLegendEntryProps>>
    | React.ReactElement<ICalendarLegendEntryProps>
}

export class CalendarLegend extends React.PureComponent<ICalendarLegendProps> {
  public render() {
    return <ul className='calendar-legend'>{this.props.children}</ul>
  }
}
